import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=b9295bea"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"
import style0 from "./menu.vue?vue&type=style&index=0&id=b9295bea&prod&lang=scss"
import style1 from "./menu.vue?vue&type=style&index=1&id=b9295bea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports